import {Component,ViewChild} from '@angular/core';

import {Nav,Platform} from 'ionic-angular';

import {StatusBar} from '@ionic-native/status-bar';

import {SplashScreen} from '@ionic-native/splash-screen';

import {TabsPage} from "../pages/tabs/tabs";
import { FCM ,NotificationData} from '@ionic-native/fcm';

import {Storage} from "@ionic/storage";

import {OrdinazioniPage} from "../pages/ordinazioni/ordinazioni";

import {UtentiPage} from "../pages/utenti/utenti";

import {ProdottiPage} from "../pages/prodotti/prodotti";
import {InforistorantePage} from "../pages/inforistorante/inforistorante";
import {OrarioPage} from '../pages/orario/orario';
import {CapconsegnaPage} from '../pages/capconsegna/capconsegna';
import {UtenticlientPage} from "../pages/utenticlient/utenticlient";

import {AuthProvider} from "../providers/auth/auth";
import {LoginPage} from "../pages/login/login";



@Component({

  templateUrl: 'app.html'

})

export class MyApp {

  rootPage: any = null;

  @ViewChild(Nav) nav: Nav;

  pages: Array<{title: string, component: any}>;

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
 
  }



  constructor(platform: Platform,

              statusBar: StatusBar,
              private readonly storage: Storage,

              splashScreen: SplashScreen,
              private fcm: FCM,

              authProvider: AuthProvider) {

//    platform.ready().then(() => {

  //    statusBar.styleDefault();

    //  splashScreen.hide();

   // });

   platform.ready().then(() => {
    // Okay, so the platform is ready and our plugins are available.
    // Here you can do any higher level native things you might need.
    console.log("platform .........start");
    //alert("platform .........start");
    statusBar.styleDefault();
    splashScreen.hide();
    /*
    this.fcm.subscribeToTopic('marketing');



    this.fcm.getToken().then(token => {
      if(token==null) {
        alert("token .........null");
        alert(JSON.stringify(this.fcm.onTokenRefresh()));
      }
      console.log("FCM getToken ........." + token);
      alert("getToken ........." + token);
     this.storage.set('fcmtoken', token);

      // backend.registerToken(token);
    });
   

    this.fcm.onNotification().subscribe(
      (data:NotificationData)=>{
        if(data.wasTapped){


          alert("Received in background:"+JSON.stringify(data))
        }else{
          alert("Received in foreground:"+JSON.stringify(data))
          for (let key in data) {
            let value = data[key];
            alert("key:"+key+" value: "+value);
            // Use `key` and `value`
        }
        }
        },error=>{
        console.error("Error in notification",error)
       }
    );


    this.fcm.onTokenRefresh().subscribe(token => {
      console.log("onTokenRefresh ........." + token);

      // backend.registerToken(token);
    });

    this.fcm.unsubscribeFromTopic('marketing');
   */
  });
     // used for an example of ngFor and navigation
     this.pages = [
      { title: 'Ordini', component: OrdinazioniPage },
      { title: 'Prodotti', component: ProdottiPage },
      { title: 'Ristorante', component: InforistorantePage },
      { title: 'Ristoranti', component: UtentiPage },
      { title: 'Orario', component: OrarioPage },
      { title: 'CAP', component: CapconsegnaPage },
      { title: 'Utenti', component: UtenticlientPage },

      
      
    ];



    authProvider.authUser.subscribe(jwt => {

      if (jwt) {

        this.rootPage = TabsPage;

      }

      else {

        this.rootPage = LoginPage;

      }

    });



    authProvider.checkLogin();

  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts